import ToppingPreference from './ToppingPreference';

export default ToppingPreference;
